import React from 'react';

import { useRoutes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useSelector } from 'react-redux';
import { useReactiveVar  } from "@apollo/client";
import RTL from './layouts/full-layout/customizer/RTL';
import ThemeSettings from './layouts/full-layout/customizer/ThemeSettings';
import Router from './routes/Router';
import LoginRouter from './routes/LoginRouter';
import { isLoggedInVar } from './apollo';
import 'react-perfect-scrollbar/dist/css/styles.css';


const App = () => {
  const routing = useRoutes(Router);
  const loginrouting = useRoutes(LoginRouter);
  const theme = ThemeSettings();

  const customizer = useSelector((state) => state.CustomizerReducer);

  const isLoggedIn = useReactiveVar(isLoggedInVar);
 
  return (

     <ThemeProvider theme={theme}>
       <RTL direction={customizer.activeDir}>
         <CssBaseline />
         {isLoggedIn ? routing : loginrouting }
        </RTL>
      </ThemeProvider>

  );
};

export default App;
